const ICON_SIZE = 32;
const ICON_COUNT = 3;

function setPixel(atlas: Uint8Array, icon: number, x: number, y: number, alpha = 255): void {
  if (x < 0 || x >= ICON_SIZE || y < 0 || y >= ICON_SIZE) {
    return;
  }
  atlas[y * ICON_SIZE * ICON_COUNT + icon * ICON_SIZE + x] = alpha;
}

/** Generates dot/cross/minus masks once per WebGL context, never per strike. */
export function createLightningIconAtlas(): { pixels: Uint8Array; width: number; height: number } {
  const pixels = new Uint8Array(ICON_SIZE * ICON_COUNT * ICON_SIZE);
  const center = ICON_SIZE / 2;

  for (let y = 0; y < ICON_SIZE; y++) {
    for (let x = 0; x < ICON_SIZE; x++) {
      const dx = x + 0.5 - center;
      const dy = y + 0.5 - center;
      if (dx * dx + dy * dy <= 10) {
        setPixel(pixels, 0, x, y);
      }
      if ((Math.abs(dx) <= 1.5 && Math.abs(dy) <= 10) || (Math.abs(dy) <= 1.5 && Math.abs(dx) <= 10)) {
        setPixel(pixels, 1, x, y);
      }
      if (Math.abs(dy) <= 1.5 && Math.abs(dx) <= 10) {
        setPixel(pixels, 2, x, y);
      }
    }
  }

  return { pixels, width: ICON_SIZE * ICON_COUNT, height: ICON_SIZE };
}
